module.exports = __webpack_public_path__ + "static/3-27749a5b0b37868e00718f9ac5327bd2.png";